<nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top">
  <div class="container">
    <!-- Brand Logo -->
    <a class="navbar-brand" routerLink="/">
      <app-logo size="medium" [showText]="true" [showTagline]="false" [textOnly]="true"></app-logo>
    </a>

    <!-- Mobile Toggle Button -->
    <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navigation Menu -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto align-items-center">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="bi bi-house me-1"></i>Home
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/products" routerLinkActive="active">
            <i class="bi bi-award me-1"></i>Certifications
          </a>
        </li>
        
        <!-- Authenticated User Navigation -->
        <ng-container *ngIf="isAuthenticated$ | async">
          <li class="nav-item">
            <a class="nav-link" routerLink="/dashboard" routerLinkActive="active">
              <i class="bi bi-speedometer2 me-1"></i>Dashboard
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/submissions" routerLinkActive="active">
              <i class="bi bi-file-text me-1"></i>My Submissions
            </a>
          </li>

        </ng-container>
        
        <li class="nav-item">
          <a class="nav-link" routerLink="/pricing" routerLinkActive="active">
            <i class="bi bi-tags me-1"></i>Pricing
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/about" routerLinkActive="active">
            <i class="bi bi-info-circle me-1"></i>About
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/contact" routerLinkActive="active">
            <i class="bi bi-envelope me-1"></i>Contact
          </a>
        </li>
        
        <!-- Auth Buttons -->
        <ng-container *ngIf="!(isAuthenticated$ | async)">
          <li class="nav-item ms-lg-3">
            <a class="btn btn-outline-primary btn-sm" routerLink="/login" routerLinkActive="active">
              <i class="bi bi-box-arrow-in-right me-1"></i>Login
            </a>
          </li>
          <li class="nav-item ms-lg-2">
            <a class="btn btn-primary btn-sm" routerLink="/register" routerLinkActive="active">
              <i class="bi bi-person-plus me-1"></i>Get Started
            </a>
          </li>
        </ng-container>
        
        <!-- User Menu for Authenticated Users -->
        <ng-container *ngIf="isAuthenticated$ | async">
          <li class="nav-item dropdown ms-lg-3">
            <button class="nav-link dropdown-toggle d-flex align-items-center border-0 bg-transparent" 
                    type="button"
                    (click)="toggleDropdown($event)">
              <i class="bi bi-person-circle me-1"></i>
              <span>{{ getUserDisplayName(currentUser$ | async) || 'Loading...' }}</span>
            </button>
            <ul class="dropdown-menu" [class.show]="isDropdownOpen">
              <li><a class="dropdown-item" routerLink="/profile" (click)="closeDropdown()">
                <i class="bi bi-person me-2"></i>My Profile
              </a></li>
              <li><a class="dropdown-item" routerLink="/submissions" (click)="closeDropdown()">
                <i class="bi bi-file-text me-2"></i>My Submissions
              </a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" href="#" (click)="signOut($event)">
                <i class="bi bi-box-arrow-right me-2"></i>Sign Out
              </a></li>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</nav>